import { render, staticRenderFns } from "./InfoDetail.vue?vue&type=template&id=a6ce8e88&scoped=true"
import script from "./InfoDetail.vue?vue&type=script&lang=js"
export * from "./InfoDetail.vue?vue&type=script&lang=js"
import style0 from "./InfoDetail.vue?vue&type=style&index=0&id=a6ce8e88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6ce8e88",
  null
  
)

export default component.exports